// extracted by mini-css-extract-plugin
export default {"dynamic-split-layout":"H1b333","dynamicSplitLayout":"H1b333"};